
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  text?: string;
  textClassName?: string;
}

export function Loader({ 
  size = "md", 
  className, 
  text,
  textClassName 
}: LoaderProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8"
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <Loader2 
        className={cn(
          "animate-spin text-primary", 
          sizeClasses[size],
          className
        )} 
      />
      {text && (
        <p className={cn("mt-2 text-muted-foreground text-sm", textClassName)}>
          {text}
        </p>
      )}
    </div>
  );
}

export function FullPageLoader({ text = "Loading..." }: { text?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <Loader size="lg" text={text} />
    </div>
  );
}
